import React, { useMemo } from 'react';
import { useTheme } from 'styled-components';
import { Assets } from "../../assets";
import { ButtonContainer, ButtonText, StyledClipLoader } from "./Button.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A simple button component with the possibility to add icons to the left and right of the label, and a loader icon when loading.

 * @param label The label text to display on the button
 * @param variant The variant style of the button
 * @param color The color of the button
 * @param size The size of the button
 * @param disabled The disabled state of the button
 * @param Loading The loading state of the button
 * @param fullWidth The full width state of the button
 * @param lefticon the icon on the left side of the text
 * @param righticon the icon on the right side of the text
 * @param onPress The function to be called when the button is pressed
 */
const Button = props => {
  const {
    label,
    variant = 'filled',
    color = 'primary',
    size = 'md',
    disabled = false,
    loading = false,
    fullWidth = false,
    leftIcon,
    rightIcon,
    onPress,
    ...rest
  } = props;
  const theme = useTheme();
  const iconColor = useMemo(() => {
    if (loading) {
      return 'transparent';
    } else if (variant === 'filled' || color === 'secondary') {
      return `${theme?.colors?.neutralL5}`;
    } else if (variant === 'outline' || variant === 'ghost') {
      if (color === 'primary') {
        return `${theme?.colors?.primary}`;
      } else if (color === 'danger') {
        return `${theme?.colors?.error}`;
      }
    }
    return `${theme?.colors?.neutralL5}`;
  }, [loading, variant, color, theme]);
  const LeftIconComp = leftIcon && Assets[leftIcon];
  const RightIconComp = rightIcon && Assets[rightIcon];
  return /*#__PURE__*/_jsx(ButtonContainer, {
    ...rest,
    type: "button",
    variant: variant,
    color: color,
    size: size,
    disabled: disabled,
    fullWidth: fullWidth,
    onClick: onPress,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [LeftIconComp && /*#__PURE__*/_jsx(LeftIconComp, {
        size: size === 'lg' ? 'md' : 'sm',
        color: iconColor
      }), loading && /*#__PURE__*/_jsx(StyledClipLoader, {
        sizeicon: size
      }), /*#__PURE__*/_jsx(ButtonText, {
        variant: variant,
        color: iconColor,
        size: size,
        children: label
      }), RightIconComp && /*#__PURE__*/_jsx(RightIconComp, {
        size: size === 'lg' ? 'md' : 'sm',
        color: iconColor
      })]
    })
  });
};
export { Button };